<template>
    <section class="edge-container" v-if="filters.length || moreFilters.length">
        <div :class="accordionWrapperClass">
            <div :class="['product-finder', 'background', background]">
                <div class="container">
                    <sal-accordion :init-open="true" v-if="useAccordion">
                        <template slot="header">
                            <h3 v-html="localization.accordionHeader"></h3>
                        </template>

                        <template slot="body">
                            <template v-if="filters.length">
                                <sal-filter-group :filters="filters"></sal-filter-group>
                            </template>

                            <template v-if="moreFilters.length">
                                <p class="group__label" v-html="localization.labels.moreFilters"></p>
                                <sal-filter-group v-for="filterGroup in groupedMoreFilters" :key="filterGroup[0]" :filters="filterGroup[1]"></sal-filter-group>
                            </template>
                        </template>
                    </sal-accordion>
                    <div class="product-finder__filterarea" v-else>
                        <template v-if="filters.length">
                            <sal-filter-group :filters="filters"></sal-filter-group>
                        </template>

                        <template v-if="moreFilters.length">
                            <p class="group__label" v-html="localization.labels.moreFilters"></p>
                            <sal-filter-group v-for="filterGroup in groupedMoreFilters" :key="filterGroup[0]" :filters="filterGroup[1]"></sal-filter-group>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <sal-filter-selected></sal-filter-selected>
                </div>
            </div>
        </div>

        <div class="container">
            <sal-results class="row"></sal-results>
        </div>
    </section>
</template>

<script>
import SalAccordion from "@productfinder/components/sal-accordion/sal-accordion";
import SalFilterGroup from "@productfinder/components/sal-filter-group/sal-filter-group";
import SalFilterSelected from "@productfinder/components/sal-filter-selected/sal-filter-selected";
import SalResults from "@productfinder/components/sal-results/sal-results";

export default {
        name: "product-finder",
        components: {SalResults, SalFilterSelected, SalFilterGroup, SalAccordion},
        props: {
            searchUrl: ''
        },
        data() {
            return {}
        },
        computed: {
            filters() {
                return this.$store.getters.filters;
            },
            localization() {
                return this.$store.state.localization;
            },
            background() {
                return this.$store.state.background;
            },
            groupedMoreFilters() {
                const moreFilters = this.$store.getters.moreFilters;
                const groupedMoreFilters = new Map();
                moreFilters.forEach((filter, key) => {
                    if (!groupedMoreFilters.has(filter.group)) {
                        groupedMoreFilters.set(filter.group, []);
                    }
                    groupedMoreFilters.get(filter.group).push(filter);
                });
                return Array.from(groupedMoreFilters);
            },
            moreFilters() {
                return this.$store.getters.moreFilters;
            },
            useAccordion() {
                return this.$store.state.config.useAccordion;
            },
            accordionWrapperClass() {
                if (this.$store.state.config.layout === 'content') {
                    return 'container';
                }
                return null;
            }
        },
        methods: {
		},
        beforeMount() {
            this.$store.dispatch('setConfig');
            this.$store.dispatch('setLocalization');
            this.$store.dispatch('setApi');
            this.$store.dispatch('loadInitialData');

            window.addEventListener('hashchange', (e) => {
                if (!this.$store.state.freeze && '#'+this.$store.state.hash !== window.location.hash) {
                    this.$store.dispatch('loadInitialData');
                }
            });
        }
    }
</script>
